import { VideoMaterial } from '../../services/videoMaterialApi/videoMaterialApi.types';

export type { VideoMaterial };

/** 1動画に添付できる資料の最大数（backend の MAX_MATERIALS_PER_VIDEO と一致させること） */
export const MAX_MATERIALS_PER_VIDEO = 3;

/** 資料1件あたりの上限サイズ（backend の MAX_MATERIAL_FILE_SIZE_BYTES と一致させること） */
export const MAX_MATERIAL_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export interface VideoEditMaterialsSectionProps {
  /** 対象の動画ID。session_ プレフィックス（処理中動画）では何もしない */
  videoId: string;
  /** 動画が処理中（変換中）かどうか。true の間は資料欄を無効化表示する */
  isVideoProcessing?: boolean;
}

export interface UseVideoEditMaterialsSectionReturn {
  materials: VideoMaterial[];
  isLoading: boolean;
  isUploading: boolean;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  isDragging: boolean;
  /** 院外接続かどうか。true の間は追加・削除のUIを非活性にする */
  isExternalNetwork: boolean;
  handleFileButtonClick: () => void;
  handleFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDragLeave: () => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
  handleDelete: (id: number) => void;
  formatFileSize: (bytes: number) => string;
}
